import { render, staticRenderFns } from "./paper_list.vue?vue&type=template&id=b50750f8&scoped=true"
import script from "./paper_list.vue?vue&type=script&lang=js"
export * from "./paper_list.vue?vue&type=script&lang=js"
import style0 from "./paper_list.vue?vue&type=style&index=0&id=b50750f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50750f8",
  null
  
)

export default component.exports